import { Card, CircularProgress, Grid, Icon, Link } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
import { useNotification } from "context/NotificationContext";
import documentService from "../../../../../../services/documentService";
import PropTypes from "prop-types";

const ListDocument = (props) => {
  const { expedienteId, refreshDocuments } = props;
  const { showNotification } = useNotification();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchDocuments() {
      setLoading(true);
      const data = await documentService.getDocumentbyExpedienteId(expedienteId);
      if (Array.isArray(data)) {
        setDocuments(data);
      } else {
        showNotification("Error al cargar los documentos", "error");
      }
      setLoading(false);
    }
    fetchDocuments();
  }, [expedienteId, refreshDocuments]);

  if (loading) {
    return (
      <MDBox display="flex" justifyContent="center" p={2}>
        <CircularProgress size={24} color="info" />
      </MDBox>
    );
  }

  if (documents.length === 0) {
    return null;
  }

  const listDocuments = documents.map((x) => (
    <Grid key={x.id} item xs={12} md={6} lg={4}>
      <Card>
        <Link href={`/file/detail/${expedienteId}/document/${x.id}`} color="inherit" underline="none">
          <MDBox p={2} pb={1}>
            <Grid container spacing={2}>
              <Grid item>
                <MDBox
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="center"
                >
                  <MDTypography variant="h2" color="info">
                    <Icon>description</Icon>
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item>
                <MDBox
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="center"
                >
                  <MDTypography variant="button" fontWeight="medium">
                    {x.name}
                  </MDTypography>
                  <MDTypography variant="caption" color="dark">
                    {x.created_date}
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </Link>
      </Card>
    </Grid>
  ));

  return (
    <Grid container spacing={2}>
      {listDocuments}
    </Grid>
  );
};

ListDocument.propTypes = {
  expedienteId: PropTypes.number.isRequired,
  refreshDocuments: PropTypes.bool,
};

export default ListDocument;
